module.exports = __webpack_public_path__ + "static/media/sg.dd08107f.svg";